__turbopack_context__.v({
  "card": "StatsWidget-module__7a1ESW__card",
  "hint": "StatsWidget-module__7a1ESW__hint",
  "label": "StatsWidget-module__7a1ESW__label",
  "pulse": "StatsWidget-module__7a1ESW__pulse",
  "skeleton": "StatsWidget-module__7a1ESW__skeleton",
  "value": "StatsWidget-module__7a1ESW__value",
});
